import { useMutation } from '@tanstack/react-query';
import { bulkReleaseInvestmentWorkflow } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useWorkflowProgress } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/WorkflowProgress/WorkflowProgressContext';

export const useBulkReleaseMutation = (mipId: string) => {
	const tMipManage = useTranslationMipManage();
	const { startReleaseWorkflow } = useWorkflowProgress();

	return useMutation({
		mutationFn: (investorsIds: string[]) =>
			bulkReleaseInvestmentWorkflow({ selectedIds: investorsIds, mipId }),
		onSuccess: (response) => {
			startReleaseWorkflow(response.payload?.releaseTsaWorkflowHandle);
		},
		onError: () => {
			showToastV2({
				title: tMipManage('investors.release_error'),
				state: 'error',
			});
		},
	});
};
